// Time entry redux action types. Backs the per-tech labor-time logging on a work order.

export const FETCH_TIME_ENTRIES = 'FETCH_TIME_ENTRIES';
export const FETCH_TIME_ENTRIES_SUCCESS = 'FETCH_TIME_ENTRIES_SUCCESS';
export const FETCH_TIME_ENTRIES_FAIL = 'FETCH_TIME_ENTRIES_FAIL';

export const START_TIME_ENTRY = 'START_TIME_ENTRY';
export const START_TIME_ENTRY_SUCCESS = 'START_TIME_ENTRY_SUCCESS';
export const START_TIME_ENTRY_FAIL = 'START_TIME_ENTRY_FAIL';

export const STOP_TIME_ENTRY = 'STOP_TIME_ENTRY';
export const STOP_TIME_ENTRY_SUCCESS = 'STOP_TIME_ENTRY_SUCCESS';
export const STOP_TIME_ENTRY_FAIL = 'STOP_TIME_ENTRY_FAIL';

export const ADD_MANUAL_TIME_ENTRY = 'ADD_MANUAL_TIME_ENTRY';
export const ADD_MANUAL_TIME_ENTRY_SUCCESS = 'ADD_MANUAL_TIME_ENTRY_SUCCESS';
export const ADD_MANUAL_TIME_ENTRY_FAIL = 'ADD_MANUAL_TIME_ENTRY_FAIL';

export const UPDATE_TIME_ENTRY = 'UPDATE_TIME_ENTRY';
export const UPDATE_TIME_ENTRY_SUCCESS = 'UPDATE_TIME_ENTRY_SUCCESS';
export const UPDATE_TIME_ENTRY_FAIL = 'UPDATE_TIME_ENTRY_FAIL';

export const DELETE_TIME_ENTRY = 'DELETE_TIME_ENTRY';
export const DELETE_TIME_ENTRY_SUCCESS = 'DELETE_TIME_ENTRY_SUCCESS';
export const DELETE_TIME_ENTRY_FAIL = 'DELETE_TIME_ENTRY_FAIL';

export const CLEAR_TIME_ENTRY_MESSAGES = 'CLEAR_TIME_ENTRY_MESSAGES';

export const SET_USER_HOURLY_RATE = 'SET_USER_HOURLY_RATE';
export const SET_USER_HOURLY_RATE_SUCCESS = 'SET_USER_HOURLY_RATE_SUCCESS';
export const SET_USER_HOURLY_RATE_FAIL = 'SET_USER_HOURLY_RATE_FAIL';
